import { useEffect, useState } from "react";
import { getDetailNotice, getListNotice } from "../api";

export const useListNotice = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListNotice({ status: 1, ...params });
    if (response?.status) setData(response?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
export const useDetailNotice = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getDetailNotice({ status: 1, ...params });
    if (response?.status) setData(response?.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
